import { CircularProgress, Flex } from '@chakra-ui/react';
import { InfiniteQueryObserverResult } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useIntersection } from 'react-use';

interface UseLoadingMoreProps {
  canLoadMore?: boolean;
  loadMore?: () => Promise<InfiniteQueryObserverResult<any>>;
  root?: any | null;
}

export const useLoadingMore = ({
  canLoadMore,
  loadMore,
  root,
}: UseLoadingMoreProps): React.ReactElement => {
  const intersectionRef = useRef(null);
  const intersection = useIntersection(intersectionRef, {
    root,
    rootMargin: '200px 0px 0px 0px',
    threshold: 0,
  });

  useEffect(() => {
    if (canLoadMore && loadMore && intersection?.isIntersecting) {
      loadMore();
    }
  }, [canLoadMore, intersection?.isIntersecting, loadMore]);

  return (
    <Flex
      alignItems="center"
      // eslint-disable-next-line tailwindcss/no-custom-classname
      className="loader"
      justifyContent="center"
      ref={intersectionRef}
    >
      {canLoadMore && intersection?.isIntersecting && (
        <CircularProgress
          aria-label="Loading more"
          color="primary.200"
          isIndeterminate
          paddingBottom="10px"
          size={6}
          trackColor="transparent"
        />
      )}
    </Flex>
  );
};
